
import React, { createContext, useState, useContext, useCallback } from 'react';
import { toast } from 'sonner';

interface WaitlistContextType {
  email: string;
  setEmail: (email: string) => void;
  showConfetti: boolean;
  handleWaitlistSubmit: (e: React.FormEvent) => void;
  scrollToWaitlist: () => void;
}

const WaitlistContext = createContext<WaitlistContextType | undefined>(undefined);

export const WaitlistProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [email, setEmail] = useState('');
  const [showConfetti, setShowConfetti] = useState(false);
  
  const handleWaitlistSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }
    
    toast.success("You've been added to our waitlist! We'll be in touch soon.");
    setEmail('');
    setShowConfetti(true);
    
    setTimeout(() => {
      setShowConfetti(false);
    }, 3000);
  }, [email]);

  const scrollToWaitlist = useCallback(() => {
    document.getElementById('waitlist-form')?.scrollIntoView({ behavior: 'smooth' });
  }, []);
  
  return (
    <WaitlistContext.Provider value={{
      email,
      setEmail,
      showConfetti,
      handleWaitlistSubmit,
      scrollToWaitlist
    }}>
      {children}
    </WaitlistContext.Provider>
  );
};

export const useWaitlist = (): WaitlistContextType => {
  const context = useContext(WaitlistContext);
  if (context === undefined) {
    throw new Error('useWaitlist must be used within a WaitlistProvider');
  }
  return context;
};
